import React, { useState } from 'react';
import { Input } from 'antd';
import Alert from '@mui/material/Alert';
import { Button } from 'antd';
import { Typography } from 'antd';
import { Calculator } from './Calculator';

import './App.css';

const { Title } = Typography;

export function Password() {
  const [enteredPassword, setEnteredPassword] = useState("password");
  const [correct, setCorrect] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const changePassword = (value) => {
    setEnteredPassword(value)
  }

  const checkPassword = () => {
    if (enteredPassword === 'cherrytree') {
      setCorrect(true);
      setPasswordError(false);
    } else {
      setCorrect(false);
      setPasswordError(true);
    }
  }

  return (
    <>
      {correct === false && (

        <div className='calculator'>
          <div className='section'>
            <Title level={4}>Please enter the password below:</Title>

            <Input.Password placeholder='Password' size="large" onChange={(e) => changePassword(e.target.value)} />
            {passwordError && <Alert severity="error">Incorrect password, please try again or get in touch with someone from the Airwise team.</Alert>}
          </div>

          <Button className='calculate' onClick={checkPassword}>Enter</Button>
        </div>)
      }

      {correct === true && (
        <Calculator />
      )}
    </>
  )
}